import gsap from 'gsap';
import {$dom} from '../../../helpers/dom';
import {$style} from '../../../helpers/style';

const {
	get
} = $dom;

const {
	offset
} = $style;

export default function statisticsTradeLines() {
	const
		tradeLineRedSelector = '.js-line-red',
		tradeLineBlueSelector = '.js-line-blue',
		tradePointRedLeftSelector = '.js-point-red-left',
		tradePointRedRightSelector = '.js-point-red-right',
		tradePointBlueLeftSelector = '.js-point-blue-left',
		tradePointBlueRightSelector = '.js-point-blue-right',
		tradeWrapSelector = '.js-statistics-chart-wrap'
	;

	function setTradeLinePosition(lineSelector, leftPointSelector, rightPointSelector) {

		const point = get('[class*="js-point-"]');

		const
			tradeWrapOffsetLeft = offset(tradeWrapSelector).left,
			leftPointOffsets = offset(leftPointSelector),
			rightPointOffsets = offset(rightPointSelector),
			pointSize = gsap.getProperty(point, 'width')
		;


		gsap.set(lineSelector, {
			width: ((rightPointOffsets.left - tradeWrapOffsetLeft) - (leftPointOffsets.left - tradeWrapOffsetLeft)) + 'px',
			left: leftPointOffsets.left - tradeWrapOffsetLeft + (pointSize / 2),
			top: Math.min(rightPointOffsets.top, leftPointOffsets.top) - offset(lineSelector).top + (pointSize / 2)
		});

	}

	function setPosition() {
		setTradeLinePosition(tradeLineBlueSelector, tradePointBlueLeftSelector, tradePointBlueRightSelector);
		setTradeLinePosition(tradeLineRedSelector, tradePointRedLeftSelector, tradePointRedRightSelector)
	}

	return {setPosition}
}
